<template>
  <div class="LoadingBar w-full">
    <div class="bar h-12 border-b-2"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  props: {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss">
  .LoadingBar {
    .bar {
      animation: pulse 1s infinite;
      animation-delay: 0s;
    }
  }

  @keyframes pulse {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
</style>
